module.exports = __webpack_public_path__ + "img/sidebar_sp1.png";